import { render, staticRenderFns } from "./image-card.vue?vue&type=template&id=2a913b58&scoped=true"
import script from "./image-card.vue?vue&type=script&lang=js"
export * from "./image-card.vue?vue&type=script&lang=js"
import style0 from "./image-card.vue?vue&type=style&index=0&id=2a913b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a913b58",
  null
  
)

export default component.exports